"use client";

import * as React from "react";
import { Sidebar, Header } from "@/components/layout";
import { AuthGuard } from "@/components/auth";
import { useVertical } from "@/contexts";

function DynamicTitle() {
  const { config } = useVertical();

  React.useEffect(() => {
    document.title = `${config.branding.appName} | ${config.branding.subtitle}`;
  }, [config]);

  return null;
}

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthGuard>
      <DynamicTitle />
      <div className="min-h-screen bg-background">
        <Sidebar />
        <div className="pl-64">
          <Header />
          <main className="p-8">{children}</main>
        </div>
      </div>
    </AuthGuard>
  );
}
